const $ = jQuery.noConflict();

class EqualContentHeight {
    constructor(column, columnContent) {
        this.column = column;
        this.columnContent = columnContent;
    }
    setEqualContentHeight() {
        const columnsContent = $(this.columnContent);
        columnsContent.matchHeight({
            byRow: false,
            property: 'height',
        });
    }
    init() {
        this.setEqualContentHeight();
    }
}

const equal_content_1 = new EqualContentHeight('.block-icon-text .column-content', '.column-top');
const equal_content_2 = new EqualContentHeight('.menu-grid .row', '.column-3 .bottom-row');
const equal_content_3 = new EqualContentHeight('.two-image-row .row', '.image-link-content');

export default equal_content_1;
export { equal_content_2, equal_content_3 };

